import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import FormField from "./EventoFormField";
import formCadastroEvento from "../schemas/forms";
import { ChangeEvent } from "react";

// Material ui Icon
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";

const { formField } = formCadastroEvento;
const { urlFacebookDivulgacao, urlInstagramDivulgacao, urlVideoDivulgacao } =
  formField;

interface FieldDetailsProps {
  values: {
    [x: string]: string;
  };
  handleBlur: {
    (e: React.FocusEvent<any>): void;
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
  };
  handleChange: {
    (e: ChangeEvent<any>): void;
    <T = string | ChangeEvent<any>>(
      field: T
    ): T extends ChangeEvent<any>
      ? void
      : (e: string | ChangeEvent<any>) => void;
  };
}

export default function FieldLinkDivulgacao({
  values,
  handleBlur,
  handleChange,
}: FieldDetailsProps) {
  return (
    <Card id="divulgacao" sx={{ overflow: "visible", margin: "10px 0" }}>
      <MDBox p={3} lineHeight={1}>
        <MDBox mb={1}>
          <MDTypography variant="h5">Links divulgação</MDTypography>
        </MDBox>
      </MDBox>

      <MDBox p={3} px={3}>
        <Grid container spacing={3} sx={{ my: 1 }}>
          <Grid item xs={12} sm={4}>
            <MDBox position="relative" height="100%" width="100%">
              <MDBox position="absolute" right={10} top={14}>
                <YouTubeIcon className="absolute" fontSize="small" />
              </MDBox>
              <FormField
                type={urlVideoDivulgacao.type}
                label={urlVideoDivulgacao.label}
                name={urlVideoDivulgacao.name}
                // error={Boolean(touched.urlVideoDivulgacao && errors.urlVideoDivulgacao)}
                placeholder="https://..."
                variant="outlined"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.urlVideoDivulgacao}
                InputLabelProps={{ shrink: true }}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox position="relative" height="100%" width="100%">
              <MDBox position="absolute" right={10} top={14}>
                <InstagramIcon className="absolute" fontSize="small" />
              </MDBox>
              <FormField
                type={urlInstagramDivulgacao.type}
                label={urlInstagramDivulgacao.label}
                name={urlInstagramDivulgacao.name}
                // error={Boolean(touched.urlInstagramDivulgacao && errors.urlInstagramDivulgacao)}
                placeholder="https://..."
                variant="outlined"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.urlInstagramDivulgacao}
                InputLabelProps={{ shrink: true }}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={4}>
            <MDBox position="relative" height="100%" width="100%">
              <MDBox position="absolute" right={10} top={14}>
                <FacebookIcon className="absolute" fontSize="small" />
              </MDBox>
              <FormField
                type={urlFacebookDivulgacao.type}
                label={urlFacebookDivulgacao.label}
                name={urlFacebookDivulgacao.name}
                // error={Boolean(touched.urlFacebookDivulgacao && errors.urlFacebookDivulgacao)}
                placeholder="https://..."
                variant="outlined"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.urlFacebookDivulgacao}
                InputLabelProps={{ shrink: true }}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}
